import { render, staticRenderFns } from "./IconCommentAdd.vue?vue&type=template&id=44047962&"
import script from "./IconCommentAdd.vue?vue&type=script&lang=js&"
export * from "./IconCommentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports